/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 10:06:04
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-10 10:18:37
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/PickAndPack/index.tsx
 */
import { get } from 'lodash';
//import css from './css.module.less';
import React from 'react';
import { SectionWrapper } from 'src/components/Layouts';
//import Category from './Components/Category';
import {
  Delivery,
  ReadyToPack,
  ReadyToShip,
} from 'src/pages/Order/AllOrders/OrderDetail/ParcelProcess';
import { IFulfillmentStatus } from 'src/types/common/order';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const PickAndPack = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { data, orderNo, onUpdate, onUndo, disabled, disablePrint } = props;
  const pickedItems = get(data, IFulfillmentStatus.READY_TO_PACK, []);
  const packedItems = get(data, IFulfillmentStatus.READY_TO_SHIP, []);
  const deliveryItems = get(data, IFulfillmentStatus.READY_TO_COLLECT, []);
  const deliveringItems = get(data, IFulfillmentStatus.DELIVERING, []);
  const errorItems = get(data, IFulfillmentStatus.ERROR, []);
  const deliveredItems = get(data, IFulfillmentStatus.DELIVERED, []);
  const deliveryAllItems = deliveryItems
    .concat(deliveringItems)
    .concat(deliveredItems)
    .concat(errorItems);

  //const delivery = get(data, IFulfillmentStatus.DELIVERING, []);+get(data, IFulfillmentStatus.DELIVERING, []);

  return (
    <React.Fragment>
      {(!!pickedItems.length ||
        !!packedItems.length ||
        !!deliveryAllItems.length) && (
        <SectionWrapper
          title={getI18n(`allOrders.orderDetail.pickandpack_return_title`)}>
          {!!pickedItems.length && (
            <ReadyToPack
              data={pickedItems}
              disabled={disabled}
              orderNo={orderNo}
              onUpdate={onUpdate}
              onUndo={onUndo}
              disablePrint={disablePrint}
            />
          )}
          {!!packedItems.length && (
            <ReadyToShip
              data={packedItems}
              disabled={disabled}
              orderNo={orderNo}
              onUpdate={onUpdate}
              onUndo={onUndo}
              disablePrint={disablePrint}
            />
          )}
          {!!deliveryAllItems.length && (
            <Delivery
              data={deliveryAllItems}
              disabled={disabled}
              orderNo={orderNo}
              onUpdate={onUpdate}
              onUndo={onUndo}
              disablePrint={disablePrint}
            />
          )}
          {/* <Category
          title={'Delivering'}
          data={[
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSN8V4fHd3cHJcSb90RQ_SuU4kU7Cl1gG8d1A&usqp=CAU',
              sku: 'sku-1',
              options: [
                {
                  content:
                    'Article Generator is an automatic online tool veloped to help t Article Generator is an automatic online too',
                  title:
                    'Article Generator is an automatic online tool developed to help t Article Generator is an automatic online too',
                },
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },
                {
                  content:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                  title:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                },
                {
                  content:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                  title:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                },
              ],
            },
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlrZqTCInyg6RfYC7Ape20o-EWP1EN_A8fOA&usqp=CAU',
              sku: 'sku-2',
              options: [
                { content: 1, title: 1 },
                { content: 1, title: 1 },
              ],
            },
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEpOB50Gf-839DMNoHRlYYBAWP0TN73RHsGg&usqp=CAU',
              sku: 'sku-3',
              options: [
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },

                {
                  content:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                  title:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                },
              ],
            },
          ]}
        />
        <Category
          title={'Done'}
          data={[
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlrZqTCInyg6RfYC7Ape20o-EWP1EN_A8fOA&usqp=CAU',
              sku: 'sku-2',
              options: [
                { content: 1, title: 1 },
                { content: 1, title: 1 },
              ],
            },
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEpOB50Gf-839DMNoHRlYYBAWP0TN73RHsGg&usqp=CAU',
              sku: 'sku-3',
              options: [
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },

                {
                  content:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                  title:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                },
              ],
            },
          ]}
        /> */}
        </SectionWrapper>
      )}
    </React.Fragment>
  );
};
export default PickAndPack;
